/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_TargetInputs */



/**
* | output |
* | --- |
* | "What is it about" |
*
* @param {Meetings_Exception_TargetInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_target = /** @type {((inputs?: Meetings_Exception_TargetInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_TargetInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Waarover gaat het")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sur quoi porte l'exception")
	return /** @type {LocalizedString} */ ("What is it about")
});